/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-01-22 10:10:37
 * @LastEditTime: 2025-02-19 11:27:21
 * @LastEditors: ywj@originqc.com
 */
// import { useEffect } from 'react';
// import { useRoutes, useLocation } from 'react-router-dom';
// import cookie from 'react-cookies';
// import routerConfig from '../../router';
import RouterView from '../../router/index';
import Header from '../header';
import Footer from '../footer';
// import FooterBottom from '../footer/bottom/footer-bottom';
import ToolBar from '@/components/tool-bar'
import './index.scss';

const Layout = () => { 
  // const element = useRoutes(routerConfig);
  // const location = useLocation();
  // const matchedRoute = routerConfig.find((route:any) => location.pathname.includes(route.path)  || (route.path === '/' && location.pathname === ''));

  // useEffect(() => {
  //   checkRedirect();
  // }, []);

  // const checkRedirect = () => {
  //   const { origin, pathname, search } = window.location;
  //   const lang = cookie.load('lang');
  //   const langMapLang = new Map([
  //     ['zh-CN', 'zh'],
  //     ['en-US', 'en'],
  //   ]);
  //   if (!['zh', 'en'].includes(pathname.split('/')[1])) {
  //     window.location.replace(
  //       `${origin}/${langMapLang.get(lang) || 'zh'}${pathname}${search}`
  //     );
  //   }
  // };
  return (
    <div className='layout-container'> 
      <div className="layout-content">
        <Header />
        <RouterView />
        <Footer />
        <ToolBar/>
      </div>
    </div>
  )
}

export default Layout;